import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../..';

interface InvalidCategoryImagesState {
  [catalogId: string]: {
    categoryIds: string[];
    fetching: boolean;
  };
}

const initialState: InvalidCategoryImagesState = {};

const invalidCategoryImagesSlice = createSlice({
  name: 'invalidCategoryImages',
  initialState,
  reducers: {
    setFetchingInvalidCategoryImages(
      state,
      action: PayloadAction<{ catalogId: string; fetching: boolean }>,
    ) {
      const { catalogId, fetching } = action.payload;
      if (!state[catalogId]) {
        state[catalogId] = { categoryIds: [], fetching: false };
      }
      state[catalogId].fetching = fetching;
    },
    removeCategoryFromInvalid(
      state,
      action: PayloadAction<{ catalogId: string; categoryId: string }>,
    ) {
      const { catalogId, categoryId } = action.payload;
      const catalog = state[catalogId];
      if (catalog) {
        catalog.categoryIds = catalog.categoryIds.filter((id) => id !== categoryId);
      }
    },
    setInvalidCategoryImages(
      state,
      action: PayloadAction<{ catalogId: string; categoryIds: string[] }>,
    ) {
      const { catalogId, categoryIds } = action.payload;
      if (!state[catalogId]) {
        state[catalogId] = { categoryIds: [], fetching: false };
      }
      state[catalogId].categoryIds = categoryIds;
      state[catalogId].fetching = false;
    },
    resetInvalidCategoryImages() {
      return initialState;
    },
  },
});

export const {
  setInvalidCategoryImages,
  setFetchingInvalidCategoryImages,
  removeCategoryFromInvalid,
  resetInvalidCategoryImages,
} = invalidCategoryImagesSlice.actions;

export const selectInvalidImages = (state: RootState) => state.invalidCategoryImages;

export default invalidCategoryImagesSlice.reducer;
